import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getUserExitsInParticipantTable } from "../../api/axiosInstanceApi";
import { Popover, PopoverHandler } from "@material-tailwind/react";
import TermsOfUsePopover from "./TermsOfUsePopover";
import { toast, Bounce, ToastContainer } from "react-toastify";
import { messages } from "../../utils/constantMessages";
import { getCookieByKey } from "../../api/axiosInstance";

function UuidComponent() {
  const param = useParams();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [userExist, setUserExist] = useState(false);
  const notifyError = (errorMassage: string) => {
    toast.error(errorMassage, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Bounce,
      theme: "light",
    });
  };
  const navigate = useNavigate();
  const [doesUserExitsRes, setDoesUserExitsRes]: any = useState();
  const onClose = () => {
    if (doesUserExitsRes && doesUserExitsRes.status === "success") {
      const participant_email = doesUserExitsRes.participant_email;
      const user_exist = doesUserExitsRes.user_exist;
      if (user_exist === "yes") {
        // setUserExist(true);
        navigate("/", {
          state: { participant_email, user_exist },
        });
      } else {
        // setUserExist(true);
        navigate("/login", {
          state: { participant_email, user_exist },
        });
      }
      console.log("user_exist: ", user_exist);
    } else {
      navigate("/login");
    }
  };
  async function check_user_using_uuid() {
    if (param.uuid !== undefined) {
      try {
        // setDoesUserExitsRes(
        //   (await getUserExitsInParticipantTable(param.uuid)).data
        // );
        const participantTableRes = await getUserExitsInParticipantTable(
          param.uuid
        );
        const participantTableData = participantTableRes.data;
        setDoesUserExitsRes(participantTableData)
        const participant_email = participantTableData.participant_email;
        const user_exist = participantTableData.user_exist;
        console.log(participantTableData);
        if (participantTableData.user_exist === "yes") {
          setUserExist(true);
          const cookie = getCookieByKey("mentee_access_token_cookie");
          // navigate("/");
          if (cookie !== null) {
            navigate("/");
          } else {
            navigate("/login", {
              state: { participant_email, user_exist },
            });
          }
        } else {
          setUserExist(true);
          // navigate("/login", {
          //   state: { participant_email, user_exist },
          // });
        }
      } catch (error: any) {
        setDoesUserExitsRes(error.response.data);
        notifyError(messages.UNEXPECTED_ERROR_OCCURRED);
      }
    }
  }
  useEffect(() => {
    check_user_using_uuid();
  }, []);
  return (
    <>
      {userExist ? (
        <div className="flex justify-center items-center h-full">
          <dialog open className="w-5/12  shadow-lg z-50 p-3 border rounded-xl">
            <div className="overflow-auto">
              <div className=" text-md  overflow-auto text-green-800 mb-4">
                We have made some updates to improve your login experience. We
                have sent you an email with your new login credentials. To
                access your content, use the credentials provided in the email
                to log into{"  "}
                <a
                  onClick={onClose}
                  className="text-blue-500 font-bold  cursor-pointer "
                >
                  powerguide.ai
                </a>
                .
              </div>
              <div className="text-sm overflow-auto text-green-800 mb-4">
                <span className="font-bold">Note:</span> Your account has
                already been set up, and all your data has been securely
                migrated. If you have trouble finding the email or need
                assistance, please contact us at{" "}
                <span className="font-medium">info@pm-powerconsulting.com</span>
                .
              </div>
              <div className="text-green-800">
                Please review{" "}
                <Popover
                  open={isPopoverOpen}
                  handler={() => setIsPopoverOpen(!isPopoverOpen)}
                >
                  <PopoverHandler>
                    <span className="text-blue-700 cursor-pointer">
                      terms of use and privacy policy
                    </span>
                  </PopoverHandler>
                  <TermsOfUsePopover
                    isPopoverOpen={setIsPopoverOpen}
                    setIsPopoverOpen={setIsPopoverOpen}
                  ></TermsOfUsePopover>
                </Popover>
                {"."}
              </div>
            </div>

            <form method="dialog" className="flex justify-center  pt-2">
              <button
                onClick={onClose}
                className="bg-slate-700 text-white  rounded-md px-2 py-1"
              >
                Continue
              </button>
            </form>
          </dialog>
          <ToastContainer />
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default UuidComponent;
